import Signature from "@uiw/react-signature/canvas";
import { useAudioEffects } from "../../../hooks/use-audio-effects";
import writtingSound from "../assets/audio/writting.wav";

interface Props {
  signatureCanvas: any;
  signatureParentRef: any;
  canvasWidth: number;
  inSignatureBox: boolean;
  setInSignatureBox: (val: boolean) => void;
  hasSignature: boolean;
  includeClearButton?: boolean;
  onClear: () => void;
  setHasSignature: (val: boolean) => void;
  onDone: () => void;
}

let timeout: any = null;

const ArrestSignature = ({
  signatureCanvas,
  signatureParentRef,
  canvasWidth,
  inSignatureBox,
  setInSignatureBox,
  includeClearButton,
  hasSignature,
  onClear,
  setHasSignature,
  onDone,
}: Props) => {
  const { playEffect } = useAudioEffects();

  return (
    <div
      ref={signatureParentRef}
      onMouseEnter={() => setInSignatureBox(true)}
      onMouseLeave={() => setInSignatureBox(false)}
      className="w-full pt-2 relative signature"
    >
      <p className="text-[13px] text-[#535353] text-right leading-[0.5]">
        SEMNATURA:
      </p>

      <Signature
        style={{ color: "red !important" }}
        ref={signatureCanvas}
        width={canvasWidth}
        height={100}
        options={{ size: 1.9, thinning: 0.3 }}
        className={`!bg-transparent border-[1px] border-transparent mt-2 ${
          inSignatureBox && "!border-black/10"
        }`}
        onPointer={(points) => {
          if (points.length > 0) {
            setHasSignature(true);
            playEffect(writtingSound);
            if (timeout) {
              clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
              onDone();
            }, 600);
          }
        }}
      />

      {hasSignature && includeClearButton && (
        <button
          onClick={onClear}
          type="button"
          title="Delete signature"
          className="absolute top-5 right-1 hover:scale-95 transition text-red-500 text-[13px]"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default ArrestSignature;
